import { $win } from '../utils/globals.js';

if ( $('.hero').length ) {
	$('.header').addClass('header--light');

	$win.on('load scroll resize', function(){
		let scrollTop = $win.scrollTop();
		let headerHeight = $('.header').outerHeight();

		if ( scrollTop > ($('.hero').height() - headerHeight) ) {
			$('.header').removeClass('header--light');
		} else {
			$('.header').addClass('header--light');
		}
	})
}

let lastScrollTop = 0;
let animating = false;

$win.on('scroll', function(){
	let scrollTop = $win.scrollTop();
	let st = $(this).scrollTop();
	let $header = $('.header');

	if ($header.hasClass('header--static')) {
		return;
	}

	setTimeout(function(){
		if ( scrollTop < 200 ) {
			$header.removeClass('is-hidden');
		} else {
			if ( animating ) {
				return;
			}

			if (st > lastScrollTop){
				if ( $('.hero').length ) {
					if ( st > $('.hero').height() ) {
						$header.addClass('is-hidden');
						animating = true;
						setTimeout(function(){
							animating= false;
						},300)
					}
				} else {
					$header.addClass('is-hidden');
					animating = true;
					setTimeout(function(){
						animating= false;
					},300)
				}
			} else {
				$header.removeClass('is-hidden');
				animating = true;
				setTimeout(function(){
					animating= false;
				},300)
			}
		}

		lastScrollTop = st;
	}, 300);
});
